/**
 * Where a person was going when they had to sign in, carried through the identity provider in the sign-in's state
 * and read back on /callback (Plans/identity-consolidation.md). Without it every deep link — a device, a viewer, a
 * shared URL — landed on the dashboard once signed in.
 */

let pending: string | null = null

/** The page the browser is on now, as a path; never the callback itself. */
export function currentReturnTo(): string {
  const { pathname, search, hash } = window.location
  return pathname.startsWith('/callback') ? '/' : `${pathname}${search}${hash}`
}

/** Only a path on this origin: a state that names anywhere else is ignored, so sign-in can't be made a redirector. */
export function safeReturnTo(state: unknown): string | null {
  const value = (state as { returnTo?: unknown } | null | undefined)?.returnTo
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\')) return null
  return value
}

/** Set by the sign-in callback, taken once by the /callback route. */
export function rememberReturnTo(path: string | null): void {
  pending = path
}

export function takeReturnTo(): string {
  const path = pending ?? '/'
  pending = null
  return path
}
